export enum DesignVersionEnum {
  designVersionDefault = 'V2'
} 